import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationsComponent } from './classifications/classifications.component';
import { SuppliersComponent } from './suppliers.component';
import { TaxInfosComponent } from './tax-infos/tax-infos.component';



@NgModule({
  declarations: [
    ClassificationsComponent,
    SuppliersComponent,
    TaxInfosComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class SupplierModule { }
